module.exports = __webpack_public_path__ + "static/Unique-3788ca011736efedc84fc321f21bd80f.svg";